import CryptoJS from 'crypto-js'

import http from '../http'

export class ZoomSignatureController {
    #endpoint
    #fingerprint

    #sdkKey
    #signature
    #meetingNumber
    #passWord
    #userEmail
    #userName

    constructor (endpoint, fingerprint) {
        this.#endpoint = endpoint
        this.#fingerprint = fingerprint
    }

    getSignature () {
        // Authenticated by the BFF via the shared session cookie (no Token header).
        const headers = {}
        // The backend gates live-class entry on device approval; it needs the
        // same device fingerprint the main app registered at login.
        if (this.#fingerprint) {
            headers['X-Device-Fingerprint'] = this.#fingerprint
        }
        return http.get(
            this.#endpoint,
            {
                headers
            })
            .then(res => {
                this.#sdkKey = res.data.sdkKey
                this.#signature = res.data.signature
                this.#meetingNumber = res.data.meetingNumber
                this.#passWord = res.data.encryptedPassWord ? this.#decryptPassword(res.data.encryptedPassWord) : ''
                this.#userEmail = res.data.userEmail
                this.#userName = res.data.userName
            })
            .catch(error => {
                console.log(error)
            })
    }

    #decryptPassword (encryptedPassWord) {
        const encryptionKey = process.env.VUE_APP_ZOOM_PASSWORD_KEY
        const key = CryptoJS.SHA256(encryptionKey)
        const decoded = CryptoJS.enc.Base64.parse(encryptedPassWord)
        const iv = CryptoJS.lib.WordArray.create(decoded.words.slice(0, 4), 16)
        const ciphertext = CryptoJS.lib.WordArray.create(decoded.words.slice(4), decoded.sigBytes - 16)
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: ciphertext },
            key,
            { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
        )
        return decrypted.toString(CryptoJS.enc.Utf8)
    }

    getMeetingConfigs () {
        return {
            sdkKey: this.#sdkKey,
            signature: this.#signature,
            meetingNumber: this.#meetingNumber,
            passWord: this.#passWord,
            userEmail: this.#userEmail,
            userName: this.#userName
        }
    }
}
